/**
 * Maps orchestrator intent slugs (Cloud SQL / LangGraph) to the legacy V1
 * IntentType used by Gmail and Outlook add-in contracts.
 */
export const ORCHESTRATOR_SLUG_TO_V1_INTENT = {
    availability_check_with_pricing: 'availability_check',
    availability_check: 'availability_check',
    live_availability_single: 'availability_check',
    pricing_query: 'pricing_query',
    live_availability_bulk: 'pricing_query',
    subscription_next_availability: 'pricing_query',
    order_confirmation: 'order_confirmation',
    order_note: 'order_confirmation',
    cancellation_request: 'cancellation_request',
    product_recommendation: 'product_recommendation',
    general_info: 'general_info',
    extend_rental: 'general_info',
    out_of_scope: 'out_of_scope',
};
export function mapOrchestratorSlugToV1Intent(slug) {
    if (!slug?.trim())
        return 'unknown';
    return ORCHESTRATOR_SLUG_TO_V1_INTENT[slug] ?? 'unknown';
}
/** Human-facing label for a missing-entity key on clarification cards. */
export const MISSING_ENTITY_UI_LABELS = {
    booking_reference: 'order id',
    order_id: 'order id',
    product_domain: 'product',
    date_hint: 'dates',
};
export function formatMissingEntityLabel(entityKey) {
    const trimmed = entityKey.trim();
    if (!trimmed)
        return 'details';
    return MISSING_ENTITY_UI_LABELS[trimmed] ?? trimmed.replace(/_/g, ' ');
}
export function normalizeMissingEntitiesField(raw) {
    if (Array.isArray(raw)) {
        return raw.filter((x) => typeof x === 'string' && x.trim() !== '');
    }
    if (typeof raw === 'string' && raw.trim())
        return [raw.trim()];
    return [];
}
/** When a branch is missing_entity but the array was not persisted, infer the gap. */
export function inferMissingEntitiesForSlug(intentSlug, extractedEntities) {
    const entities = extractedEntities ?? {};
    const requiredBySlug = {
        live_availability_single: ['product_domain', 'date_hint'],
        availability_check: ['product_domain', 'date_hint'],
        availability_check_with_pricing: ['product_domain', 'date_hint'],
        subscription_next_availability: ['product_domain'],
        order_confirmation: ['booking_reference'],
        order_note: ['booking_reference'],
        cancellation_request: ['booking_reference'],
    };
    const required = requiredBySlug[intentSlug ?? ''] ?? [];
    return required.filter((key) => !entities[key]?.trim());
}
/**
 * Resolve missing entity keys for Flow 2 (clarification) from terminal run branches.
 */
export function resolveMissingEntitiesFromBranches(branches) {
    if (!branches?.length)
        return [];
    const clarifier = branches.find((b) => b.status === 'missing_entity');
    if (!clarifier)
        return [];
    const fromBranch = normalizeMissingEntitiesField(clarifier.missing_entities);
    if (fromBranch.length)
        return fromBranch;
    return inferMissingEntitiesForSlug(clarifier.intent_slug, clarifier.extracted_entities);
}
//# sourceMappingURL=slugToV1.js.map